export function loadMazeSnippet(appId: string) {
  if (!appId || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const existing = document.querySelector('script[data-maze-snippet]');
  if (existing) {
    return;
  }

  let t = '';
  try {
    t = window.sessionStorage.getItem('maze-us') || '';
  } catch (_err) {
    // ignore
  }

  if (!t) {
    t = new Date().getTime().toString();
    try {
      window.sessionStorage.setItem('maze-us', t);
    } catch (_err) {
      // ignore
    }
  }

  const s = document.createElement('script');
  s.dataset.mazeSnippet = 'true';
  s.src = `https://snippet.maze.co/maze-universal-loader.js?t=${t}&apiKey=${appId}`;
  s.async = true;
  document.head.appendChild(s);
  (window as typeof window & {
    mazeUniversalSnippetApiKey?: string;
  }).mazeUniversalSnippetApiKey = appId;
}
